// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { createCompany, updateCompany } from "../../actions/companyActions";
import { fetchTierList } from "../../../admin/actions/companyAdminActions";
import { fetchSheetCompanies } from "../../../admin/actions/quoteAdminActions";
import { buildAdminCompanyHeading } from "../../components/companies/CompileCompanytoJson";
import { LoadingProgress } from "imagus-components";
import CreateCompanyForm from "../../components/companies/CreateCompanyForm";

type CreateCompanyFormReduxPropsType = {
  company: { [key: string]: * },
  openSnackbar: Function,
  onClose: Function,
  isEdit?: boolean,
  isAdmin?: boolean,
  tiers: Array<*>,
  companies: Array<*>,
  sheetCompanies: Array<*>,
  actions: {
    fetchTierList: Function,
    createCompany: Function,
    updateCompany: Function,
    fetchSheetCompanies: Function
  }
};

class CreateCompanyFormRedux extends Component<
  CreateCompanyFormReduxPropsType,
  *
> {
  componentDidMount() {
    if (this.props.tiers === null && this.props.isAdmin) {
      this.props.actions.fetchTierList();
    }

    if (this.props.sheetCompanies === null && this.props.isAdmin) {
      this.props.actions.fetchSheetCompanies();
    }
  }

  createCompany = (
    contactNumber: string,
    companyName: string,
    notes: string,
    abn: string,
    contactEmail: string,
    postcode: string,
    contactName: string,
    city: string,
    country: string,
    state: string,
    suburb: string,
    address: string,
    doneCallback: Function,
    failCallBack: Function,
    isAdmin: boolean,
    authorisedReseller: boolean,
    companyType: string,
    groupName?: string,
    tierId?: string,
    specialType?: string,
    productSheetId?: string
  ): * => {
    this.props.actions.createCompany(
      contactNumber,
      companyName,
      notes,
      abn,
      this.props.company.id,
      contactEmail,
      postcode,
      contactName,
      city,
      country,
      state,
      suburb,
      address,
      doneCallback,
      failCallBack,
      isAdmin,
      authorisedReseller,
      companyType,
      groupName,
      tierId,
      specialType,
      productSheetId
    );
  };

  updateCompany = (
    contactNumber: string,
    companyName: string,
    notes: string,
    abn: string,
    contactEmail: string,
    postcode: string,
    contactName: string,
    city: string,
    country: string,
    state: string,
    suburb: string,
    address: string,
    doneCallback: Function,
    failCallBack: Function,
    isAdmin: boolean,
    authorisedReseller?: boolean,
    companyType?: string,
    groupName?: string,
    tierId?: string,
    specialType?: string,
    productSheetId?: string,
    parentId?: string
  ): * => {
    this.props.actions.updateCompany(
      contactNumber,
      companyName,
      notes,
      abn,
      this.props.company.id,
      contactEmail,
      postcode,
      contactName,
      city,
      country,
      state,
      suburb,
      address,
      doneCallback,
      failCallBack,
      isAdmin,
      authorisedReseller,
      companyType,
      groupName,
      tierId,
      specialType,
      productSheetId,
      parentId
    );
  };

  render(): React$Element<*> {
    let tiers = null;
    let companyList = null;
    let sheets = null;

    if (this.props.isAdmin) {
      tiers =
        this.props.tiers &&
        this.props.tiers.map(
          (tier: { [key: string]: string }): * => ({
            value: tier.id,
            label: tier.name
          })
        );

      companyList =
        this.props.companies &&
        this.props.companies.map(
          (company: { [key: string]: * }): { [key: string]: * } => {
            let companyHeader = buildAdminCompanyHeading(company);
            return {
              value: companyHeader.id,
              label: companyHeader.name,
              level: companyHeader.level
            };
          }
        );

      sheets =
        this.props.sheetCompanies &&
        this.props.sheetCompanies.map(
          (sheet: *): * => ({
            value: sheet.id,
            label: sheet.description
          })
        );
    } else {
      tiers = [];
      companyList = [];
      sheets = [];
    }

    if (tiers !== null && companyList !== null && sheets !== null) {
      return (
        <CreateCompanyForm
          company={this.props.company}
          openSnackbar={this.props.openSnackbar}
          onClose={this.props.onClose}
          isEdit={this.props.isEdit}
          isAdmin={this.props.isAdmin}
          tiers={tiers}
          companyList={companyList}
          productSheets={sheets}
          createCompany={this.createCompany}
          updateCompany={this.updateCompany}
        />
      );
    } else {
      return <LoadingProgress />;
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  companies: state.v3admin.company.companies,
  tiers: state.v3admin.company.tiers,
  sheetCompanies: state.v3admin.quote.sheetCompanies
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { fetchTierList, createCompany, updateCompany, fetchSheetCompanies },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateCompanyFormRedux);
